import { Component, OnInit, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';

import {HttpClient} from '@angular/common/http';
import {ViewChild, AfterViewInit} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { AlertService } from '../../modules/core/services/alert.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { PeriodicElement } from '../workplace-pages/workplace-users/workplace-users.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'select', 'name', 'email', 'registeredDate', 'lastActiveTime', 'workplaces'
  ];
  formObject:any = {};

  data = new MatTableDataSource<PeriodicElement>([]);

  resultsLength = 0;
  isLoadingResults = true;
  query:string = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSize: number = 25;
  searchEvent = new EventEmitter();

  selection = new SelectionModel<PeriodicElement>(true, []);
  range: any;
  startDate: any;
  endDate: any;


  constructor(
    private sharedService:SharedService
    ,private alertService:AlertService
    ,private route:ActivatedRoute
  ) { }


  ngOnInit() {
    // this.database.sort = this.sort;
    this.data.sort = this.sort;
    this.route.params.subscribe(routeParams => {
      this.resetSelection();
      this.query = routeParams['q'];
      if(routeParams['q']){
        this.query = routeParams['q'];
      }
      if(routeParams['start']&&routeParams['end']){
        this.startDate = routeParams['start'];
        this.endDate = routeParams['start'];
        this.range = {
          start:routeParams['start'],
          end:routeParams['end']
        };
      }
      this.searchEvent.emit();
      this.data = new MatTableDataSource<PeriodicElement>([]);
    });

    this.route.queryParams.subscribe(queryParams => {
    });
  }
  resetSelection(){
    this.selection.clear();
  }
  rangeChange(range){
    this.range = range;
    if(!range.start&&!range.end){
      this.range = null;
    }
    this.search(this.query, this.range);
  }
  copyEmails(rows){
    let emails = '';
    emails = rows.map(function(elem){return elem.email;}).join(", ");

    this.sharedService.copyMessage(emails)
    this.alertService.showSnackBar('Copied '+rows.length + ' email(s)',3);
  }
  search(q,range){
    var params = range?range:{};
    if(q)
      params['q'] = q;
    this.sharedService.navigateTo('/users',params)
  }
  change(){
    this.data = new MatTableDataSource<PeriodicElement>([]);
    this.searchEvent.emit();
  }
  ngAfterViewInit() {
    const path = environment.celoApiEndpoint + '/api/Admin/Users'
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page, this.searchEvent)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          let params = {
            page:this.paginator.pageIndex,
            pageSize:this.pageSize
          }
          if(this.query){
            params['Search'] = this.query
          }
          if(this.range){
            params['fromCreationTime'] = this.getUTC(this.range.start)
            params['ToCreationTime'] = this.getUTC(this.range.end)
          }
          return this.sharedService.getObjectById(path,params);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.resultsLength = data.total;
          return data.data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => {
        this.data = new MatTableDataSource<PeriodicElement>([]);
        this.data = new MatTableDataSource<PeriodicElement>(data);
        this.data.sort = this.sort;
        if(!data||data.length==0){
          // this.isEmpty = true;
        }
      });
  }
  itemClick(verification){
    this.sharedService.navigate(['/user/'+verification['userId']])
  }
  getUTC(time){
    return new Date(time).toISOString();
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    let numRows;
    if(this.data&&this.data.data)
      numRows = this.data.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
      this.isAllSelected() ?
          this.selection.clear() :
          this.data.data.forEach(row => this.selection.select(row));
  }
  
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
      if (!row) {
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
}
